// extracted by mini-css-extract-plugin
export var container = "_4f-0";
export var containerTopRight = "_4f-1";